export interface WorkPackageAdminTab {
  label: string;
  value: WorkPackageAdminTabType;
}
export enum WorkPackageAdminTabType {
  DISCIPLINES = 'DISCIPLINES',
  CARD = 'CARD',
  IMPORT = 'IMPORT',
}
